import { useState } from 'react';
import { checkIsFromConferenceApp } from 'utils/Utilities';

const useIsFromConferenceApp = () => {
  const [isFromConferenceAppValue] = useState(checkIsFromConferenceApp());
  return isFromConferenceAppValue;
};

export default useIsFromConferenceApp;
